import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
// import { getService } from "../../../reducers/service";
// import { serviceNames } from "../../../utils/constants";
import * as API from "./api";
import { notify } from "../../reducers/NotifierReducer";
import { setCircularLoading } from "../../reducers/UiReducer";

const CODES_DATA = {
	vehicleStatuses: [
		{ id: "vs1", value: "In Service", isActive: true, sortOrder: 1 },
		{ id: "vs2", value: "Out of Service", isActive: true, sortOrder: 2 },
		{ id: "vs3", value: "Maintenance", isActive: true, sortOrder: 3 },
		{ id: "vs4", value: "Retired", isActive: true, sortOrder: 4 },
	],
	divisions: [
		{ id: "dv1", value: "Patrol", isActive: true, sortOrder: 1 },
		{ id: "dv2", value: "Investigations", isActive: true, sortOrder: 2 },
		{ id: "dv3", value: "Traffic", isActive: true, sortOrder: 3 },
		{ id: "dv4", value: "Command", isActive: true, sortOrder: 4 },
		{ id: "dv5", value: "SWAT", isActive: true, sortOrder: 5 },
		{ id: "dv6", value: "K-9", isActive: true, sortOrder: 6 },
		{ id: "dv7", value: "Administration", isActive: true, sortOrder: 7 },
	],
	workOrderTypes: [
		{ id: "wt1", value: "Preventative", isActive: true, sortOrder: 1 },
		{ id: "wt2", value: "Repair", isActive: true, sortOrder: 2 },
		{ id: "wt3", value: "Inspection", isActive: true, sortOrder: 3 },
	],
	workOrderStatuses: [
		{ id: "ws1", value: "Open", isActive: true, sortOrder: 1 },
		{ id: "ws2", value: "Closed", isActive: true, sortOrder: 2 },
	],
	equipmentCategoryCodes: [
		{ id: "ecc1", value: "COMM-01", isActive: true, sortOrder: 1 },
		{ id: "ecc2", value: "COMM-02", isActive: true, sortOrder: 2 },
		{ id: "ecc3", value: "TECH-01", isActive: true, sortOrder: 3 },
		{ id: "ecc4", value: "TECH-02", isActive: true, sortOrder: 4 },
		{ id: "ecc5", value: "WEAP-01", isActive: true, sortOrder: 5 },
		{ id: "ecc6", value: "WEAP-02", isActive: true, sortOrder: 6 },
		{ id: "ecc7", value: "SURV-01", isActive: true, sortOrder: 7 },
		{ id: "ecc8", value: "SURV-02", isActive: true, sortOrder: 8 },
		{ id: "ecc9", value: "SAFE-01", isActive: true, sortOrder: 9 },
		{ id: "ecc10", value: "VEHC-01", isActive: true, sortOrder: 10 },
		{ id: "ecc11", value: "MISC-01", isActive: true, sortOrder: 11 },
	],
	equipmentTypes: [
		{ id: "et1", value: "Radio", isActive: true, sortOrder: 1 },
		{ id: "et2", value: "MDT", isActive: true, sortOrder: 2 },
		{ id: "et3", value: "Rifle", isActive: true, sortOrder: 3 },
		{ id: "et4", value: "Camera", isActive: true, sortOrder: 4 },
		{ id: "et5", value: "Taser", isActive: true, sortOrder: 5 },
		{ id: "et6", value: "Vest", isActive: true, sortOrder: 6 },
		{ id: "et7", value: "Cuffs", isActive: true, sortOrder: 7 },
		{ id: "et8", value: "Other", isActive: true, sortOrder: 8 },
	],
	equipmentStatuses: [
		{
			id: "es1",
			value: "Deployed",
			isActive: true,
			sortOrder: 1,
			isCheckedOut: true,
		},
		{
			id: "es2",
			value: "Stored",
			isActive: true,
			sortOrder: 2,
			isCheckedOut: false,
		},
		{
			id: "es3",
			value: "Out of Service",
			isActive: true,
			sortOrder: 3,
			isCheckedOut: false,
		},
	],
	equipmentConditions: [
		{ id: "ec1", value: "Excellent", isActive: true, sortOrder: 1 },
		{ id: "ec2", value: "Good", isActive: true, sortOrder: 2 },
		{ id: "ec3", value: "Fair", isActive: true, sortOrder: 3 },
		{ id: "ec4", value: "Poor", isActive: true, sortOrder: 4 },
	],
	officerRanks: [
		{ id: "or1", value: "Employee", isActive: true, sortOrder: 1 },
		{ id: "or2", value: "Corporal", isActive: true, sortOrder: 2 },
		{ id: "or3", value: "Sergeant", isActive: true, sortOrder: 3 },
		{ id: "or4", value: "Lieutenant", isActive: true, sortOrder: 4 },
		{ id: "or5", value: "Captain", isActive: true, sortOrder: 5 },
		{ id: "or6", value: "Detective", isActive: true, sortOrder: 6 },
		{ id: "or7", value: "Commander", isActive: true, sortOrder: 7 },
		{ id: "or8", value: "Chief", isActive: true, sortOrder: 8 },
	],
	inspectionTypes: [
		{ id: "it1", value: "Pre-Shift", isActive: true, sortOrder: 1 },
		{ id: "it2", value: "Post-Shift", isActive: true, sortOrder: 2 },
		{ id: "it3", value: "Weekly", isActive: true, sortOrder: 3 },
		{ id: "it4", value: "Special", isActive: true, sortOrder: 4 },
	],
	serviceRequirements: [
		{
			id: "sm1",
			label: "Oil Change",
			numericValue: 3000,
			unit: "miles",
			isActive: true,
			sortOrder: 1,
		},
		{
			id: "sm2",
			label: "Tire Rotation",
			numericValue: 5000,
			unit: "miles",
			isActive: true,
			sortOrder: 2,
		},
		{
			id: "sm3",
			label: "Annual Inspection",
			numericValue: 365,
			unit: "days",
			isActive: true,
			sortOrder: 3,
		},
		{
			id: "sm4",
			label: "Brake Inspection",
			numericValue: 15000,
			unit: "miles",
			isActive: true,
			sortOrder: 4,
		},
		{
			id: "sm5",
			label: "Transmission Service",
			numericValue: 30000,
			unit: "miles",
			isActive: true,
			sortOrder: 5,
		},
		{
			id: "sm6",
			label: "Semi-Annual Inspection",
			numericValue: 180,
			unit: "days",
			isActive: true,
			sortOrder: 6,
		},
	],
};

export const useAssetSentinelData = () => {
	const dispatch = useDispatch();
	// const history = useHistory();
	const [loaded, setLoaded] = useState(false);
	const userAgency = useSelector((state) => state.user.userAgency);
	const [vehicles, setVehicles] = useState([]);
	const [workOrders, setWorkOrders] = useState([]);
	const [equipment, setEquipment] = useState([]);
	const [employees, setEmployees] = useState([]);
	const [inspections, setInspections] = useState([]);
	const [equipmentAssignmentHistory, setEquipmentAssignmentHistory] =
		useState([]);
	const [assignmentHistory, setAssignmentHistory] = useState([]);
	const [vehicleNotes, setVehicleNotes] = useState([]);
	const [checklistItems, setChecklistItems] = useState([]);
	const [fundingSources, setFundingSources] = useState([]);
	const [maintenance, setMaintenance] = useState([]);
	const [dispensableItems, setDispensableItems] = useState([]);
	const [codes, setCodes] = useState(CODES_DATA);

	useEffect(() => {
    let isMounted = true;
    
		const init = async () => {
      if (!userAgency) return;
			try {
				dispatch(setCircularLoading(true));
				setLoaded(false);
				// TODO: API CALL
				const [
					codesData,
					emps,
					vehicleList,
					workOrdersList,
					equipmentList,
					eqHist,
					vehHist,
					notes,
					insps,
					checklist,
					funding,
					maint,
					dispItems,
					// rbacUsersData,
					// rbacProfilesData,
					// rbacRolesData,
				] = await Promise.all([
					API.fetchCodes(),
					API.fetchEmployees(),
					API.fetchVehicles(),
					API.fetchWorkOrders(),
					API.fetchEquipment(),
					API.fetchEquipmentAssignmentHistory(),
					API.fetchVehicleAssignmentHistory(),
					API.fetchVehicleNotes(),
					API.fetchInspections(),
					API.fetchChecklistItems(),
					API.fetchFundingSources(),
					API.fetchMaintenance(),
					API.fetchDispensableItems().catch(() => []),
					// API.fetchRbacUsers(),
					// API.fetchRbacProfiles(),
					// API.fetchRbacRoles(),
				]);

				setCodes(codesData);
				setVehicles(vehicleList);
				setWorkOrders(workOrdersList);
				setEquipment(equipmentList);
				setEmployees(emps);
				setInspections(insps);
				setEquipmentAssignmentHistory(eqHist);
				setAssignmentHistory(vehHist);
				setVehicleNotes(notes);
				setChecklistItems(checklist);
				setFundingSources(funding);
				setMaintenance(maint);
				setDispensableItems(dispItems);

				// if (id) {
				// 	const service = getService(serviceNames.trainingCourse);

				// 	const resultData = await service.find({
				// 		query: {
				// 			id: id,
				// 			agencyId: userAgency,
				// 		},
				// 	});

				// 	const result = resultData?.data?.[0] || null;

				// 	if (!result) {
				// 		setTimeout(() => {
				// 			dispatch(
				// 				notify(
				// 					"You don't have access to this course.",
				// 					"warning",
				// 				),
				// 			);
				// 		}, 1000);
				// 		history.go(-1);
				// 		return;
				// 	}

				// 	if (isMounted && result) {
				// 		reset({
				// 			id: result.id || null,
				// 			courseName: result.courseName || "",
				// 			courseBeginDate: result.courseBeginDate
				// 				? dateTimePicker(result.courseBeginDate)
				// 				: "",
				// 			courseEndDate: result.courseEndDate
				// 				? dateTimePicker(result.courseEndDate)
				// 				: "",
				// 			location: result.location || "",
				// 			hours: result.hours || "",
				// 			category: result.category || "",
				// 			approved: result.approved || false,
				// 			courseNumber: result.courseNumber || "",
				// 			instructor: result.instructor || "",
				// 			certification: result.certification || "",
				// 			expireDate: result.expireDate
				// 				? dateTimePicker(result.expireDate)
				// 				: "",
				// 			certificationEntered:
				// 				result.certificationEntered || false,
				// 			tuitionDefault:
				// 				result.tuitionDefault === "" ||
				// 				result.tuitionDefault == null
				// 					? null
				// 					: formatToTwoDecimals(
				// 							result.tuitionDefault,
				// 						),
				// 		});
				// 	}
				// }
			} catch (error) {
				if (isMounted) {
					dispatch(
						notify("Failed to fetch training course", "error"),
					);
					// history.push(PATH_TRAINING_COURSES);
				}
			} finally {
				dispatch(setCircularLoading(false));
				setLoaded(true);
			}
		};

		init();
		return () => {
			isMounted = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		loaded,
		vehicles,
		workOrders,
		equipment,
		employees,
		inspections,
		codes,
		equipmentAssignmentHistory,
		assignmentHistory,
		vehicleNotes,
		checklistItems,
		fundingSources,
		maintenance,
		dispensableItems,
		setChecklistItems,
		setWorkOrders,
		setVehicles,
		setInspections,
	};
};
